/**
 * External PromoTix app URLs for mobile nav (staging vs production).
 * Override with REACT_APP_PROMOTIX_OFFICIAL_APP_BASE_URL when needed.
 */

const trimSlash = s => (typeof s === 'string' ? s.replace(/\/+$/, '') : '');

// Read process.env.REACT_APP_* directly: the browser build replaces these expressions with their
// values, but there is no `process` in the browser, so a `typeof process` guard made every read
// empty there (production URLs on staging).
const envOfficialAppBaseUrl = () => trimSlash(process.env.REACT_APP_PROMOTIX_OFFICIAL_APP_BASE_URL);
const envAppLogoutUrl = () => trimSlash(process.env.REACT_APP_PROMOTIX_APP_LOGOUT_URL);
const envMarketplaceRoot = () => trimSlash(process.env.REACT_APP_MARKETPLACE_ROOT_URL);

const currentOrigin = () =>
  typeof window !== 'undefined' && window.location?.origin ? window.location.origin : '';

export const officialPromotixAppBaseUrl = () => {
  const explicit = envOfficialAppBaseUrl();
  if (explicit) return explicit;

  const root = envMarketplaceRoot() || currentOrigin();
  const isStaging =
    /reseller-stg|staging|localhost|127\.0\.0\.1|concurrent-development/i.test(root);
  return isStaging
    ? 'https://promosuite.concurrent-development.promotix.com'
    : 'https://app.promotix.com';
};

/** Full URL hit in a hidden iframe on reseller logout to end the PromoTix web session. */
export const officialPromotixAppLogoutUrl = () => {
  const explicit = envAppLogoutUrl();
  if (explicit) return explicit;
  return `${officialPromotixAppBaseUrl()}/user/logout`;
};

/** Reseller marketplace home (Browse events CTA). Uses env root or current origin. */
export const resellerMarketplaceHomeUrl = () =>
  envMarketplaceRoot() || currentOrigin() || 'https://promotix.com';

export const officialMyTicketsUrl = () => `${officialPromotixAppBaseUrl()}/attendee/my-tickets`;

export const officialAmbassadorUrl = () =>
  `${officialPromotixAppBaseUrl()}/attendee/attendee-ambassador-dashboard`;

/** Nav "Create events" for guests — main PromoTix marketing site (desktop + mobile). */
export const officialCreateEventUrl = () => 'https://promotix.com/event-creators';

/** Nav "Create events" when logged in — PromoTix app create flow (staging vs production). */
export const officialLoggedInCreateEventUrl = () =>
  `${officialPromotixAppBaseUrl()}/event/create-event`;

/** Logged-in creator dashboard — manage events (staging vs production). */
export const officialManageEventsUrl = () =>
  `${officialPromotixAppBaseUrl()}/dashboard/my-events`;
